<template>
  <div class = "FAQ">
    <div class="PageHeader">
      <h2 class="PageHeader__subheading">{{ FAQTitle }}</h2>
    </div>
    <div class="RichTextArea" v-bind:is="faqComponent" :key="$parent.config"></div>
    <div class = "PageHeader">
      <h2 class="PageHeader__subheading">{{$t("gsFAQHeading")}}</h2>
    </div>
    <div class="Selection">
      <button class="Selection__item lg" v-on:click="GenerateSupportRequest(true)"><span>{{$t("yes")}}: <br>{{$t("gsClickHereReturn")}}</span></button>
      <button class="Selection__item" v-on:click="GenerateSupportRequest(false)"><span>{{$t("no")}}: <br>{{$t("gsClickHereSubmit")}}</span></button>
    </div>
  </div>
</template>

<script>
let axios = require('axios');

export default {
  name: 'GSDynamicFAQ',
  data: function() {
    return {
      FAQTitle: 'FAQs',
      FAQContent: ''
    }
  },
  methods: {
    GenerateSupportRequest(resolved) {
      if (resolved) {
/*         let state = this.$parent.getState();
        let ticketData = {
          request: {
            subject: '**FAQ-PICSOLVE.COM**',
            comment: {
              body: `
              Region: ${state.region.id}
              Issue: ${state.product.name}
              `
            },
            can_be_solved_by_me: true,
            solved: true
          }
        }
        axios({
          url: this.$parent.baseConfig.submitTicketUrl + 'requests',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.$parent.baseConfig.submitTicketApiKey
          },
          data: JSON.stringify(ticketData)
        }).then((response) => {
          this.$router.push({
            path: '/'
          })
        }).catch((err) => {
          console.log(err);
          this.$router.push({
            path: '/'
          })
        }) */

        this.$router.push({
          path: '/'
        })
      } else {
        this.$router.push({
          path: '/guest-services/supportRequest'
        })
      }
    },
    GenerateFAQ() {
      let state = this.$parent.getState();
      let config = this.$parent.config;
      this.FAQTitle = `FAQs: ${state.product.name}`;

      let universalContent = config.faq_content.filter(faq => {
        return faq.products === null && faq.sites === null
      }).map(faq => faq.content).join('<br>');

      let productUniversalContent = config.faq_content.filter(faq => {
        return !(faq.products === null || faq.sites !== null) ? faq.products.includes(state.product.id) : false;
      }).map(faq => faq.content).join('<br>');

      let productSiteSpecificContent = config.faq_content.filter(faq => {
        if (state.site !== null && faq.products !== null && faq.sites !== null) {
          return faq.products.includes(state.product.id) && faq.sites.includes(state.site.id)
        }
      }).map(faq => faq.content).join('<br>');

      this.FAQContent = `<div>${universalContent} <br> ${productUniversalContent} <br> ${productSiteSpecificContent} </div>`
    }
  },
  computed: {
    faqComponent () {
      return { template: this.FAQContent === '' ? '<div></div>' : this.FAQContent }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.GenerateFAQ()
    })
  },
  updated: function () {
    this.GenerateFAQ()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GuestServices/GSDynamicFAQ.vue